<!-- 微信支付 -->
<template>
  <div class="index">
    <div class="title">
      <span>{{ $route.name }}</span>
    </div>
    <div class="main">
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="form"
        label-width="125px"
      >
        <div class="main-title">
          <img src="@/assets/img/payCard/info.png" alt="" />
          <p>基本信息</p>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户类型" required>
              <el-radio :disabled="editDisable" v-model="form.organizationType" label="2"
                >企业</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户编号" required>
              <el-input
                v-model="merchantNumber"
                disabled
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人代表姓名" prop="legalPerson">
              <el-input
                v-model="form.legalPerson"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobilePhone">
              <el-input
                v-model="form.mobilePhone"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" required>
              <el-select
                style="width:100%"
                v-model="form.idDocType"
                placeholder="请选择"
                clearable
                :disabled="editDisable"
              >
                <el-option
                  v-for="item in idDocTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码" prop="idCardNumber">
              <el-input
                v-model="form.idCardNumber"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户名称" prop="merchantName">
              <el-input
                v-model="form.merchantName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户简称" prop="merchantShortname">
              <el-input
                v-model="form.merchantShortname"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商铺店铺地址" prop="companyAddress">
              <el-input
                v-model="form.companyAddress"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商铺链接地址" prop="storeUrl">
              <el-input v-model="form.storeUrl" placeholder="请输入" :disabled="editDisable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="contactEmail">
              <el-input
                v-model="form.contactEmail"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照注册号" prop="businessLicenseNumber">
              <el-input
                v-model="form.businessLicenseNumber"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证结束时间">
              <el-radio :disabled="editDisable" v-model="idCardValidTimeVisible" label="1"
                >有效期限</el-radio
              >
              <el-radio :disabled="editDisable" v-model="idCardValidTimeVisible" label="2"
                >长期</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="idCardValidTimeVisible == '1'">
            <el-form-item label="有效期限" required>
              <el-date-picker
                v-model="idCardValidDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
                :disabled="editDisable"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="营业期限" required>
              <el-radio :disabled="editDisable" v-model="businessTimeVisible" label="1"
                >有限期限</el-radio
              >
              <el-radio :disabled="editDisable" v-model="businessTimeVisible" label="2">长期</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="businessTimeVisible == '1'">
            <el-form-item label="有效期限" required>
              <el-date-picker
                v-model="businessDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabled="editDisable"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="upload_box" title="查看照片">
              <div class="el-upload__tip" slot="tip">证件照正面</div>
              <div
                class="uploadBtn"
                v-if="form.idCardCopy == ''"
                @click="uploadBtnClick('idCardCopy')"
              >
                <i class="el-icon-plus"></i>
              </div>
              <div class="img_box" v-else>
                <img
                  class="showImg"
                  @click="see('idCardCopy')"
                  :src="form.idCardCopy"
                  alt=""
                />
                <img
                  v-show="!editDisable"
                  class="del"
                  @click="delFile('idCardCopy')"
                  src="../../../../assets/img/del.svg"
                  alt=""
                />
              </div>
            </div>
            <input
              style="display: none"
              type="file"
              single
              ref="idCardCopy"
              @change="uploadHttpRequest"
            />
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-col>
          <el-col :span="8">
            <div class="upload_box" title="查看照片">
              <div class="el-upload__tip" slot="tip">证件照反面</div>
              <div
                class="uploadBtn"
                v-if="form.idCardNational == ''"
                @click="uploadBtnClick('idCardNational')"
              >
                <i class="el-icon-plus"></i>
              </div>
              <div class="img_box" v-else>
                <img
                  class="showImg"
                  @click="see('idCardNational')"
                  :src="form.idCardNational"
                  alt=""
                />
                <img
                  v-show="!editDisable"
                  class="del"
                  @click="delFile('idCardNational')"
                  src="../../../../assets/img/del.svg"
                  alt=""
                />
              </div>
            </div>
            <input
              style="display: none"
              type="file"
              single
              ref="idCardNational"
              @change="uploadHttpRequest"
            />
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-col>
          <el-col :span="8">
            <div class="upload_box" title="查看照片">
              <div class="el-upload__tip" slot="tip">营业执照扫描件</div>
              <div
                class="uploadBtn"
                v-if="form.businessLicenseCopy == ''"
                @click="uploadBtnClick('businessLicenseCopy')"
              >
                <i class="el-icon-plus"></i>
              </div>
              <div class="img_box" v-else>
                <img
                  class="showImg"
                  @click="see('businessLicenseCopy')"
                  :src="form.businessLicenseCopy"
                  alt=""
                />
                <img
                  v-show="!editDisable"
                  class="del"
                  @click="delFile('businessLicenseCopy')"
                  src="../../../../assets/img/del.svg"
                  alt=""
                />
              </div>
            </div>
            <input
              style="display: none"
              type="file"
              single
              ref="businessLicenseCopy"
              @change="uploadHttpRequest"
            />
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-col>
        </el-row>
        <div class="main-title line">
          <img src="@/assets/img/payCard/other.jpg" alt="" />
          <p>结算信息</p>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="账户名" prop="accountName">
              <el-input
                v-model="form.accountName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行名称" prop="accountBank">
              <el-input
                v-model="form.accountBank"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开户行" prop="bankName">
              <el-input :disabled="editDisable" v-model="form.bankName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行缩写">
              <el-input
                v-model="form.bankShortName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="账号" prop="accountNumber">
              <el-input
                v-model="form.accountNumber"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账户使用类型">
              <el-radio :disabled="editDisable" v-model="form.bankAccountType" label="74"
                >对公</el-radio
              >
              <el-radio :disabled="editDisable" v-model="form.bankAccountType" label="75"
                >对私</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="卡类型" required>
              <el-radio v-model="form.cardType" label="1">借记卡</el-radio>
              <el-radio v-model="form.cardType" label="2">信用卡</el-radio>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="8">
            <el-form-item label="开户行所在地" required>
              <el-select
               :disabled="editDisable"
                style="margin-right: 10px"
                v-model="form.bankAddressCode.proviceCode"
                @change="
                  (val) => {
                    handleProviceChange(val);
                  }
                "
                clearable
                filterable
                placeholder="请选择省"
              >
                <el-option
                  v-for="item in proviceList"
                  :key="item.area_code"
                  :label="item.area_name"
                  :value="item.area_code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-select
             :disabled="editDisable"
              style="margin-right: 10px"
              v-model="form.bankAddressCode.cityCode"
              @change="
                (val) => {
                  handleCityChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择市"
            >
              <el-option
                v-for="item in cityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
             :disabled="editDisable"
              v-model="form.bankAddressCode.areaCode"
              @change="
                (val) => {
                  handleAreaChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择区"
            >
              <el-option
                v-for="item in areaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form>
      <div class="main-title line">
        <div class="btn_box">
          <el-button
            type="primary"
            :disabled="saveDisable"
            size=""
            @click="save()"
          >
            {{ saveDisable ? "提交中" : "确定" }}
          </el-button>
          <el-button size="" @click="cancel()">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNextAreaInfo } from "@/api/user/userCenter";
import { createWechatMer } from "@/api/mechanismApi/curriculum.js";
import util from "@/utils/util.js";
import UploadService from "@/utils/fileCenter/tencentCloud.upload";
import {
  validatePhone,
  validateEMail,
  validateIdcard,
  validateAccountNumber,
} from "@/utils/validate.js";
import dayjs from "dayjs";
export default {
  components: {},
  data() {
    return {
      form: {
        organizationType: "2", //13034407878  420281199111111299   武汉市江夏区华师园北路89号 91420106MA49DJNX1A  6212261612004897709
        businessLicenseCopy: "",
        businessLicenseNumber: "",
        merchantName: "",
        companyAddress: "",
        businessTime: "",
        legalPerson: "",
        idCardCopy: "",
        idCardNational: "",
        idCardNumber: "",
        idCardValidTime: "",
        mobilePhone: "",
        contactEmail: "",
        bankAccountType: "74",
        accountBank: "",
        accountName: "",
        bankName: "",
        accountNumber: "",
        storeUrl: "",
        merchantShortname: "",
        bankShortName: "",
        idDocType: "IDENTIFICATION_TYPE_IDCARD",
        bankAddressCode: {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
        },
      },
      merchantNumber:
        sessionStorage.getItem("platformCode") +
        sessionStorage.getItem("orgId")||'',
      idCardValidDate: "",
      businessDate: "",
      idCardValidTimeVisible: "1",
      businessTimeVisible: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      saveDisable: false,
      editDisable:false,
      proviceList: [], //省列表数据
      cityList: [], //市列表数据
      areaList: [], //区列表数据
      val1List: [{ value: "1", lable: "专业服务" }],
      val2List: [{ value: "1", lable: "教育服务" }],
      val3List: [{ value: "1", lable: "中小学校(民办)" }],
      val4List: [{ value: "1", lable: "请选择" }],
      uploading: false,
      info:{},
      idDocTypeList: [
        {
          id: "0",
          label: "中国大陆居民-身份证",
          value: "IDENTIFICATION_TYPE_IDCARD",
        },
        {
          id: "1",
          label: " 其他国家或地区居民-护照",
          value: "IDENTIFICATION_TYPE_OVERSEA_PASSPORT",
        },
        {
          id: "2",
          label: "中国香港居民-来往内地通行证",
          value: "IDENTIFICATION_TYPE_HONGKONG_PASSPORT",
        },
        {
          id: "3",
          label: "中国澳门居民-来往内地通行证",
          value: "IDENTIFICATION_TYPE_MACAO_PASSPORT",
        },
        {
          id: "4",
          label: "中国台湾居民-来往大陆通行证",
          value: "IDENTIFICATION_TYPE_TAIWAN_PASSPORT",
        },
      ],
      uploadType: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rules: {
        legalPerson: [
          { required: true, message: "请输入法人代表姓名", trigger: "blur" },
        ],
        mobilePhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        idCardNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
        ],
        merchantName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
        ],
        merchantShortname: [
          { required: true, message: "请输入商户简称", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "请输入商铺店铺地址", trigger: "blur" },
        ],
        storeUrl: [
          { required: true, message: "请输入商铺链接地址", trigger: "blur" },
        ],
        contactEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEMail, trigger: "blur" },
        ],
        businessLicenseNumber: [
          { required: true, message: "请输入营业执照注册号", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        accountName: [
          { required: true, message: "请输入账户名", trigger: "blur" },
        ],
        accountBank: [
          { required: true, message: "请输入银行名称", trigger: "blur" },
        ],
        bankName: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        accountNumber: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validateAccountNumber, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  created() {
    this.handleAreaList();
    console.log("获取跳转的参数", this.$route.query);
    this.init();
  },
  methods: {
    dayjs,
    init() {
      this.editDisable=this.$route.query.type=='see'?true:false
      let _info=this.info
      _info= this.$route.query.info;
      if (_info) {
        for (var k in _info) {
          this.form[k] = _info[k];
        }
        if(typeof this.form.bankAddressCode != 'object'){
          this.form.bankAddressCode={
            proviceCode: "",
            proviceName: "",
            cityCode: "",
            cityName: "",
            areaCode: "",
            areaName: "",
          }
        }
      }
    },
    async save() {
      let _this = this.form;
      if (_this.idCardCopy == "") {
        this.$message({
          type: "error",
          message: "请上传证件照正面",
        });
        return;
      } else if (_this.idCardNational == "") {
        this.$message({
          type: "error",
          message: "请上传证件照反面",
        });
        return;
      } else if (_this.businessLicenseCopy == "") {
        this.$message({
          type: "error",
          message: "请上传营业执照扫描件",
        });
        return;
      } else if (_this.bankAddressCode.proviceCode == "") {
        this.$message({
          type: "error",
          message: "请选择开户行所在地",
        });
        return;
      }
      let params = {
        loginPlatformCode: sessionStorage.getItem("loginPlatformCode") || "",
        platformCode: sessionStorage.getItem("platformCode") || "",
        usessionid: sessionStorage.getItem("usessionid") || "",
        orgId: sessionStorage.getItem("orgId") || "",
        organizationType: "2",
        businessLicenseCopy: _this.businessLicenseCopy,
        businessLicenseNumber: _this.businessLicenseNumber,
        merchantName: _this.merchantName,
        companyAddress: _this.companyAddress,
        businessTime:
          this.businessTimeVisible == "2"
            ? "长期"
            : `[${dayjs(this.businessDate[0]).format("YYYY-MM-DD")}, ${dayjs(
                this.businessDate[1]
              ).format("YYYY-MM-DD")}]`,
        legalPerson: _this.legalPerson,
        idCardCopy: _this.idCardCopy,
        idCardNational: _this.idCardNational,
        idCardNumber: _this.idCardNumber,
        idCardValidTime:
          this.idCardValidTimeVisible == "2"
            ? "长期"
            : dayjs(this.idCardValidDate[1]).format("YYYY-MM-DD"),
        mobilePhone: _this.mobilePhone,
        contactEmail: _this.contactEmail,
        bankAccountType: _this.bankAccountType,
        accountBank: _this.accountBank,
        accountName: _this.accountName,
        bankName: _this.bankName,
        accountNumber: _this.accountNumber,
        storeUrl: _this.storeUrl,
        merchantShortname: _this.merchantShortname,
        idDocType: _this.idDocType,
        bankAddressCode: _this.bankAddressCode,
      };
      // let testData = {
      //   loginPlatformCode: "420100",
      //   platformCode: "420100",
      //   usessionid: "14b85440e6c911ec9d170203156781ac",
      //   orgId: "c1791a9eba0911ec8ce0f2b2d3432abf",
      //   organizationType: "2",
      //   accountBank: "中国建设银行",
      //   accountName: "高小帅",
      //   accountNumber: "6212261612004897709",
      //   bankAccountType: "74",
      //   bankAddressCode: {
      //     areaCode: "420103",
      //     areaName: "江汉区",
      //     cityCode: "420100",
      //     cityName: "武汉市",
      //     proviceCode: "420000",
      //     proviceName: "湖北省",
      //   },
      //   bankName: "中国建设银行股份有限公司武汉球场街支行",
      //   businessLicenseCopy:
      //     "http://khfw-1256736654-cdn.huijiaoyun.com/420100/2022/06/08/09/44/c1628176ba0911ec8ce0f2b2d3432abf/f08e7618-3785-6641-fe8d-30ad769a0f40/1654652690.png?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDaw0sXJg9D1Z4KLai3A1dP0MJJDtVYdpm%26q-sign-time%3D1654652693%3B3231452693%26q-key-time%3D1654652693%3B3231452693%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D1cc481d257930b9959a4136011ae83af48da0954",
      //   businessLicenseNumber: "91420106MA49DJNX1A",
      //   businessTime: "['2012-06-08', '2022-06-08']",
      //   companyAddress: "武汉市江夏区华师园北路89号",
      //   contactEmail: "2517838529@qq.com",
      //   idCardCopy:
      //     "http://khfw-1256736654-cdn.huijiaoyun.com/420100/2022/06/08/09/44/c1628176ba0911ec8ce0f2b2d3432abf/e02ca360-5a85-9770-a25b-ce19ec95b299/1654652678.jpeg?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDaw0sXJg9D1Z4KLai3A1dP0MJJDtVYdpm%26q-sign-time%3D1654652681%3B3231452681%26q-key-time%3D1654652681%3B3231452681%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Dd50ee798651462ebc7855082499e3bd36dff9eb9",
      //   idCardNational:
      //     "http://khfw-1256736654-cdn.huijiaoyun.com/420100/2022/06/08/09/44/c1628176ba0911ec8ce0f2b2d3432abf/694eac51-98ec-6af2-43f4-ff2246a0e973/1654652684.png?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDaw0sXJg9D1Z4KLai3A1dP0MJJDtVYdpm%26q-sign-time%3D1654652687%3B3231452687%26q-key-time%3D1654652687%3B3231452687%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D9d62dafb4242728114c37dd0f668f87a99509efd",
      //   idCardNumber: "420281199111111299",
      //   idCardValidTime: "2032-06-04",
      //   idDocType: "IDENTIFICATION_TYPE_IDCARD",
      //   legalPerson: "陈开发",
      //   loginPlatformCode: "420100",
      //   merchantName: "皇中皇烧饼",
      //   merchantShortname: "烧饼",
      //   mobilePhone: "13034407878",
      //   orgId: "c1791a9eba0911ec8ce0f2b2d3432abf",
      //   organizationType: "2",
      //   platformCode: "420100",
      //   storeUrl: "https://www.hao123.com/?tn=88013251_20_hao_pg",
      //   usessionid: "14b85440e6c911ec9d170203156781ac",
      // };
      console.log("点击了保存", params);
      this.$refs["rulesForm"].validate(async (valid) => {
        if (valid) {
          try {
            this.saveDisable = true;
            const { result, data, desc } = await createWechatMer(params);
            if (result == "000000") {
              this.$message({
                type: "success",
                message: "开通成功",
              });
              this.$router.go(-1);
              this.resetForm();
              // this.$refs["rulesForm"].resetFields(); //重置表单
            } else {
              this.$message({
                type: "error",
                message: desc,
              });
              this.saveDisable = false;
            }
          } catch (e) {
            console.error(e);
          } finally {
            console.log("最后执行---");
            this.saveDisable = false;
          }
        } else {
          this.$message({
            type: "error",
            message: "请输入必填",
          });
        }
      });
    },
    resetForm() {
      let _this = this.form;
      for (let k in _this) {
        this.form[k] = "";
      }
      _this.organizationType = "2";
      _this.bankAccountType = "74";
      _this.idDocType = "IDENTIFICATION_TYPE_IDCARD";
      _this.bankAddressCode = {
        proviceCode: "",
        proviceName: "",
        cityCode: "",
        cityName: "",
        areaCode: "",
        areaName: "",
      };
    },
    cancel() {
      this.$router.go(-1);
    },
    handleLimit(file, fileList) {
      // console.log('触发file',fileList);
      // if (fileList.length >= 1) {
      //    this.$message.error('只能上传一张照片！');
      // }
      // this.$forceUpdate();
    },
    beforeUpload(fileList) {
      console.log("上传前---", fileList);
    },
    handleSuccess(response, file, fileList) {
      console.log("上传成功111---", response, file);
      if (file.url) {
        this.eqForm.image = file.url;
      }
    },
    uploadBtnClick(type) {
      this.uploadType = type;
      this.$refs[type].click();
    },
    async uploadHttpRequest(e) {
      const sourceFiles = this.$refs[this.uploadType].files[0];
      console.log("---sourceFiles", sourceFiles);
      this.uploadInstance = new UploadService({
        appType: "khfw",
        userInfo: {
          userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
          platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
            .platformCode,
        },
      });
      let ext = util.getFileExt(sourceFiles["name"]);
      if (sourceFiles["size"] == 0) {
        //大小为0的文件
        this.$message({
          message: `文件${sourceFiles["name"]}是空文件,请重新上传`,
          type: "error",
          duration: 1000,
        });
        return;
      }
      this.uploadInstance
        .upload(sourceFiles, {
          onProgress: (progress) => {},
        })
        .then((res) => {
          if (res.code == "000000") {
            // let fileObj = {
            //   name: sourceFiles["name"],
            //   size: this.formatFileSize(sourceFiles.size),
            //   fileLength: sourceFiles.size,
            //   type: this.getExt(ext),
            //   ext: ext,
            //   fid: res.data.fid,
            //   downloadUrl: res.data.downloadUrl,
            //   previewUrl: res.data.previewUrl,
            // };
            // this.form[this.uploadType].push(fileObj);
            this.form[this.uploadType] =
              res.data.previewUrl || res.data.downloadUrl;
            this.$forceUpdate();

            console.log("上传完的文件---", this.form[this.uploadType]);
          } else {
            this.$message({
              message: "上传失败",
              type: "error",
              duration: 1000,
            });
          }
          e.target.value = "";
        });
    },
    see(url) {
      this.dialogVisible = true;
      this.dialogImageUrl = this.form[url];
      this.$forceUpdate();
    },
    delFile(type) {
      this.form[type] = "";
      let uploadInput = this.$refs[this.uploadType];
      uploadInput.value = "";
      this.$forceUpdate();
    },
    handleAreaList() {
      // 用户中心获取全部省的数据
      getNextAreaInfo({ area_code: "0" }).then((res) => {
        if (res.code == "000000") {
          this.proviceList = res.result;
        }
      });
    },
    async handleProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function(item) {
        return item.area_code === areaCode;
      });
      this.form.bankAddressCode.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.cityList = result;
      }
      this.form.bankAddressCode.cityCode = "";
      this.form.bankAddressCode.cityName = "";
      this.form.bankAddressCode.areaCode = "";
      this.form.bankAddressCode.areaName = "";
    },
    async handleCityChange(areaCode) {
      var obj = {};
      obj = this.cityList.find(function(item) {
        return item.area_code === areaCode;
      });
      this.form.bankAddressCode.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.areaList = result;
      }
      this.form.bankAddressCode.areaCode = "";
      this.form.bankAddressCode.areaName = "";
    },
    async handleAreaChange(areaCode) {
      var obj = {};
      obj = this.areaList.find(function(item) {
        return item.area_code === areaCode;
      });
      this.form.bankAddressCode.areaName = obj.area_name;
    },
    getExt(ext) {
      return util.getFileType(ext);
    },
    formatFileSize(limit) {
      limit = limit * 1;
      let size = "";
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      let sizeStr = size + ""; // 转成字符串
      let index = sizeStr.indexOf("."); // 获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou === "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0 30px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

.main {
  width: 100%;
  height: 100%;
  margin-top: 3%;
  .main-title {
    display: flex;
    align-items: center;
    margin-bottom: 2%;
    .btn_box {
      margin: 2% auto;
    }
    &.line {
      border-top: 1px solid #eaeaea;
      padding-top: 3%;
      margin-top: 6%;
    }
    p {
      font-weight: bold;
      font-size: 14px;
      color: #181c26;
      margin-left: 10px;
    }
  }
  .upload_box {
    width: 148px;
    height: 148px;
    cursor: pointer;
    .el-upload__tip {
      margin-bottom: 10px;
    }
    .uploadBtn {
      width: 100%;
      height: 100%;
      border-radius: 5%;
      background: #fbfdff;
      border: 1px dashed #c0ccda;
    }
    .uploadBtn:hover {
      border: 1px dashed #44a0ff;
    }
    .img_box {
      width: 148px;
      height: 148px;
      position: absolute;
      .showImg {
        width: 148px;
        height: 148px;
        top: 0px;
        left: 0px;
      }
      .del {
        position: relative;
        height: 20px;
        width: 20px;
        cursor: pointer;
        top: -100%;
        left: 85%;
      }
    }
  }
}
.el-upload--picture-card {
  display: none;
}
.el-icon-plus {
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 38%;
  font-size: 30px;
  color: #8c939d;
}
</style>
